import { all, takeEvery, put, select } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
import profileActions from '../profile/actions';
import usersActions from '../users/actions';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL,
  headers: {
    Authorization: localStorage.getItem('access_token')
  }
}

export function* getEmpresas( action ) {
  const res = yield gaxios.request({
    url: 'api/empresas',
    headers: {
      Authorization:localStorage.getItem('access_token'),
      AuthId: localStorage.getItem('id_token')
    }
  }); 
  yield put({ 
    type: actions.UPDATE_EMPRESAS,
    empresas: res.data,
  });
}

export function* getEmpresasUsuario( action ) {
  const res = yield gaxios.request({
    url: 'api/empresas/user/'+action.id,
    headers: {
      Authorization:localStorage.getItem('access_token'),
      AuthId: localStorage.getItem('id_token')
    }
  }); 
  if( res.data.success){
    if( action.usuarios){
      yield put({ 
        type: usersActions.CUERRENT_USER,
        currentUserEmpresas: res.data.empresas,
      });
    }else{
      yield put({ 
        type: profileActions.PROFILE_EMPRESAS,
        empresas: res.data.empresas,
      });
    }
    
  }
  
}

export function* getEmpresaEdit( action ) {
  const res = yield gaxios.request({
    url: `api/empresas/${action.id}`,
  }); 
  if(res.data.success){
    yield put({
      type: actions.UPDATE_EDIT_EMPRESA,
      empresa: res.data.empresa,
    });
  }
  
}

export function* updateEmpresaSaga({ empresas, empresa }) {
  const res = yield gaxios.request({
    url: 'api/empresas',
  });
  yield put({
    type: actions.UPDATE_EMPRESA,
    res,
    empresa,
  });
}

export function* createEmpresaSaga( empresa ) {
  let ULRDestino = "api/empresas";
  let metodo = "POST";
  if(empresa.accion) {
    const estado = yield select();
    ULRDestino = `api/empresas/${empresa.data.id}`;
    metodo = "PUT";
  }
  yield put({
    type: actions.CREATE_EMPRESA,
  });
  const res = yield gaxios.request({
    url: ULRDestino,
    data: empresa.data,
    method: metodo,
  });
  if( res.data.success ){
    console.log(res.data);
    notification('success', res.data.msg )
    yield put({
      type: actions.GET_EMPRESAS,
    });
    yield put({
      type: actions.SELECT_CURRENT_EMPRESA,
      empresa: res.data.empresa,
      
    });
  }else{
    yield put({
      type: actions.CREATE_EMPRESA_ERROR,
    });
    notification('error', res.data.msg );
  }
};

export function* getComentarios( action ){
  const res = yield gaxios.request({
    url: `api/comentarios/empresa/${action.id}`,
    headers: {
      Authorization:localStorage.getItem('access_token'),
      AuthId: localStorage.getItem('id_token')
    }
  });
  if (res.data.success){
    yield put({ 
      type: actions.COMENTARIOS_EMPRESA,
      comentarios: res.data.comentarios,
    });
  }
}

export function* eliminarComentario( action ){
  let ULRDestino = "api/comentarios/"+action.id;
  let metodo = "DELETE";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
  });
  if( res.data.success ){
   console.log(res.data)
    notification('success', res.data.msg );
    yield put({ 
      type: actions.GET_COMENTARIOS,
      id: action.current,
    });
  }else{
    notification('error', res.data.msg );
  }
}
export function* editEmpresaSaga( empresa, _id ) {
  const ULRDestino = `api/empresas/${empresa._id}`;
  const metodo = "PUT";
  yield put({
    type: actions.CREATE_EMPRESA,
  });
  const res = yield gaxios.request({
    url: ULRDestino,
    data: empresa.data,
    method: metodo,
  });
  if( res.data.success ){
    notification('success', res.data.msg )
    yield put({
      type: actions.GET_EMPRESAS,
    });
  }else{
    yield put({
      type: actions.CREATE_EMPRESA_ERROR,
    });
    notification('error', res.data.msg );
  }
  
};

export function* eliminarEmpresa( action ) {
  let ULRDestino = "api/empresas/"+action.id;
  let metodo = "DELETE";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
  });
  if( res.data.success ){
    yield put({ 
      type: actions.GET_EMPRESAS
    });
    notification('success', res.data.msg )
  }else{
    notification('error', res.data.msg );
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_EMPRESAS, getEmpresas),
    yield takeEvery(actions.GET_EMPRESAS_USER, getEmpresasUsuario),
    yield takeEvery(actions.GET_EMPRESA_EDIT, getEmpresaEdit),
    yield takeEvery(actions.UPDATE_EMPRESA_SAGA, updateEmpresaSaga),
    yield takeEvery(actions.EDIT_EMPRESA_SAGA, editEmpresaSaga),
    yield takeEvery(actions.CREATE_EMPRESA_SAGA, createEmpresaSaga),
    yield takeEvery(actions.DELETE_EMPRESA, eliminarEmpresa),
    yield takeEvery(actions.DELETE_COMENTARIO, eliminarComentario),
    yield takeEvery(actions.GET_COMENTARIOS, getComentarios),
  ]);
}
